import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../lib/api";
import { PortalLayout } from "../components/portal/PortalLayout";
import { SRReadOnly, SRStatoBadge } from "../components/portal/SRForm";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Skeleton } from "../components/ui/skeleton";
import { formatDateTime } from "../lib/format";
import { ArrowLeft, Lock, Check } from "lucide-react";

const STEPS = [["ricevuta", "Ricevuta"], ["presa_in_carico", "Presa in carico"], ["assegnata", "Assegnata"]];

const Stepper = ({ stato }) => {
  const idx = STEPS.findIndex(([k]) => k === stato);
  return (
    <ol data-testid="portal-stepper" className="flex items-center gap-2 mb-6">
      {STEPS.map(([k, label], i) => (
        <li key={k} className="flex items-center gap-2 flex-1">
          <span className={`h-7 w-7 shrink-0 rounded-full flex items-center justify-center text-xs font-bold ${i <= idx ? "bg-primary text-white" : "bg-slate-200 text-slate-500"}`}>
            {i < idx ? <Check className="h-3.5 w-3.5" /> : i + 1}
          </span>
          <span className={`text-xs sm:text-sm ${i <= idx ? "font-semibold text-slate-800" : "text-slate-400"}`}>{label}</span>
          {i < STEPS.length - 1 && <span className={`h-0.5 flex-1 ${i < idx ? "bg-primary" : "bg-slate-200"}`} />}
        </li>
      ))}
    </ol>
  );
};

export default function PortalRequestView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    const load = () => api.get(`/portale/richieste/${id}`).then(({ data }) => setD(data)).catch(() => setErr(true));
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [id]);

  return (
    <PortalLayout>
      <Button variant="ghost" size="sm" className="gap-1 mb-3 -ml-2" onClick={() => navigate("/strutture")}><ArrowLeft className="h-4 w-4" /> Le tue richieste</Button>
      {err ? <p className="text-sm text-slate-500 py-10 text-center">Richiesta non trovata.</p> : !d ? <Skeleton className="h-80 w-full" /> : (
        <>
          <div className="flex flex-wrap items-center gap-3 mb-1">
            <h1 data-testid="portal-view-code" className="text-3xl font-bold font-heading text-slate-900 tracking-tight">{d.code}</h1>
            <SRStatoBadge stato={d.stato} testid="portal-view-stato" />
          </div>
          <p className="text-sm text-slate-500 mb-6">Inviata il {formatDateTime(d.created_at)} da {d.created_by_name}</p>
          <Stepper stato={d.stato} />
          <Card className="p-6 border-slate-200">
            <p className="flex items-center gap-1.5 text-xs text-slate-400 mb-4"><Lock className="h-3.5 w-3.5" /> Sola lettura: la richiesta non è modificabile dopo l'invio.</p>
            <SRReadOnly data={d} />
          </Card>
        </>
      )}
    </PortalLayout>
  );
}
